"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisitorId = getVisitorId;
exports.getBeaconServerUrl = getBeaconServerUrl;

function getVisitorId() {
  var visitorKey = 'visitor';
  var cookies = document.cookie.split(';');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var c = _step.value;

      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(visitorKey) == 0) {
        var start = c.indexOf('=') + 2;
        var end = c.length - 1;
        return c.substring(start, end);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  ;
  return '';
}

function getBeaconServerUrl(env) {
  if (env === 'production') {
    return 'https://beacon.shutterfly.com/log';
  }

  return "https://beacon.".concat(env, ".shutterfly.com/log");
}